const dataURLs = {
  mapData: `${process.env.PUBLIC_URL}/data/ilf-map-data.json`,
};

export const getMapData = () => {
  return fetch(dataURLs.mapData).then((response) => response.json());
};
